"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSVFileImportPage = exports.CSVFileImportPageConfig = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var core_shared_1 = require("@ikegps/core-shared");
var mobx_1 = require("mobx");
var image_button_1 = require("../../components/button/image.button");
var file_upload_1 = require("../../components/file.upload/file.upload");
var icon_1 = require("../../components/icon");
var icons_1 = require("../../components/icon/icons");
var input_select_1 = require("../../components/input/input.select");
var tag_input_state_1 = require("../../components/input/tag.input.state");
var modal_service_1 = require("../../components/modal/modal.service");
var modal_style_1 = require("../../components/modal/modal.style");
var notification_service_1 = require("../../components/notification.toast/notification.service");
var spinner_1 = require("../../components/spinner/spinner");
var theme_1 = require("../../components/theme");
var i18n_1 = require("../../i18n");
var mithril_1 = require("../../mithril");
var export_notification_detail_ctrl_1 = require("../../modules/export.notification/export.notification.detail/export.notification.detail.ctrl");
var services_1 = require("../../services");
var store_1 = require("../../store");
var classnames_1 = require("../../util/classnames");
var page_1 = require("../page");
var import_ctrl_1 = require("./import.ctrl");
var import_style_1 = require("./import.style");
var MAX_COLLECTIONS = 500;
var COLLECTION_CHUNK = 25;
exports.CSVFileImportPageConfig = {
    type: 'internal',
    name: page_1.IkePageName.collectionImport,
    path: '/collection/import',
    auth: {
        required: true,
        tokens: [core_api_1.IkeToken.FEATURE_IMPORT_CSV],
        userLevel: [core_api_1.IkeUserRole.USER, core_api_1.IkeUserRole.ROOT, core_api_1.IkeUserRole.DATA_ADMIN]
    },
    nav: {
        name: i18n_1.T.LIST_COLLECTION_IMPORT,
        icon: icons_1.MaterialIcon.INBOX
    }
};
var CSVFileImportPage = /** @class */ (function (_super) {
    tslib_1.__extends(CSVFileImportPage, _super);
    function CSVFileImportPage() {
        var _this = _super.call(this, exports.CSVFileImportPageConfig) || this;
        _this.form = new input_select_1.SelectInputState('Select a Form');
        _this.fileUpload = new file_upload_1.FileUploadComponent();
        _this.csvImport = new import_ctrl_1.CSVFormImportControl();
        _this.isImporting = false;
        _this.progressCurrent = 0;
        _this.progressTotal = 0;
        _this.mode = null; // Initial value is set in constructor
        _this.tabs = [];
        _this.activeTab = 0;
        _this.tag = new tag_input_state_1.TagNameInputState();
        _this.tag.state.setAutoFocus(true);
        _this.reaction(function () { return _this.mode; }, function () {
            if (_this.mode === 'EXCEL') {
                _this.fileUpload.uploadType = 'buffer';
            }
            if (_this.mode === 'CSV') {
                _this.fileUpload.uploadType = 'text';
            }
        });
        _this.reaction(function () { return _this.fileUpload.file && _this.fileUpload.file.text; }, _this.processCSVFile);
        _this.reaction(function () { return _this.fileUpload.file && _this.fileUpload.file.isFailed; }, _this.processFileFailure);
        _this.reaction(function () { return _this.form.value; }, _this.processCSVFile);
        _this.reaction(function () { return store_1.AppStore.FormSummary.all; }, _this.processFormList);
        // Select initial mode (active tab) based on permissions
        if (_this.canImportExcel) {
            _this.mode = 'EXCEL';
            _this.fileUpload.uploadType = 'buffer';
        }
        else if (_this.canImportCSV) {
            _this.mode = 'CSV';
            _this.fileUpload.uploadType = 'text';
        }
        // If we're navigating back to this page, and the FormSummaries have already been loaded in the app store
        // the above reaction will never be triggered and the form list will never be populated. This
        // manually calls the processFormList method to ensure it's populated regardless.
        _this.processFormList(store_1.AppStore.FormSummary.all);
        _this.tabs = tslib_1.__spreadArray(tslib_1.__spreadArray([], (_this.canImportExcel ? [{ title: (0, i18n_1.Translate)(i18n_1.T.EXCEL_BETA), onSelect: function () { return _this.mode = 'EXCEL'; } }] : []), true), (_this.canImportCSV ? [{ title: (0, i18n_1.Translate)(i18n_1.T.CSV), onSelect: function () { return _this.mode = 'CSV'; } }] : []), true);
        _this.isImporting = false;
        return _this;
    }
    Object.defineProperty(CSVFileImportPage.prototype, "canImportCSV", {
        get: function () {
            return this.isCorrectUserType && services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_IMPORT_CSV);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CSVFileImportPage.prototype, "canImportExcel", {
        get: function () {
            return this.isCorrectUserType && services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_IMPORT_EXCEL);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CSVFileImportPage.prototype, "canImport", {
        get: function () {
            return this.canImportCSV || this.canImportExcel;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CSVFileImportPage.prototype, "isExcelImport", {
        get: function () {
            return this.mode === 'EXCEL';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CSVFileImportPage.prototype, "isCSVImport", {
        get: function () {
            return this.mode === 'CSV';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CSVFileImportPage.prototype, "isCorrectUserType", {
        get: function () {
            var userProfile = services_1.Services.UserProfile.get(services_1.Services.User.current.objectId);
            return services_1.Services.UserProfile.canImportCollections(userProfile);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CSVFileImportPage.prototype, "isValid", {
        get: function () {
            var _a, _b;
            if (this.tagName == null) {
                return false;
            }
            if (this.isExcelImport) {
                return (((_a = this.fileUpload.file) === null || _a === void 0 ? void 0 : _a.type) === file_upload_1.EXCEL_MIME_TYPE || ((_b = this.fileUpload.file) === null || _b === void 0 ? void 0 : _b.type) === file_upload_1.OPEN_EXCEL_MIME_TYPE);
            }
            if (this.isCSVImport) {
                if (!this.csvImport.isValid) {
                    return false;
                }
                if (this.csvImport.collections.length > MAX_COLLECTIONS ||
                    this.csvImport.collections.length < 1) {
                    return false;
                }
            }
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CSVFileImportPage.prototype, "tagName", {
        get: function () {
            var tagValue = this.tag.value;
            if (tagValue == null || tagValue.trim() === '') {
                return null;
            }
            return tagValue;
        },
        enumerable: false,
        configurable: true
    });
    CSVFileImportPage.prototype.processCSVFile = function () {
        // Only run if CSV import is selected
        if (!this.isCSVImport) {
            return;
        }
        if (this.form.value == null) {
            this.csvImport.reset();
            return;
        }
        var file = this.fileUpload.file;
        if (file == null) {
            this.csvImport.reset();
            return;
        }
        var text = this.fileUpload.file.text;
        if (text == null) {
            this.csvImport.reset();
            return;
        }
        try {
            this.csvImport.process(this.form.value, new core_shared_1.IkeCSV(text));
        }
        catch (e) {
            notification_service_1.NotificationService.error({ key: i18n_1.T.FILE_NOT_SUPPORTED });
            this.fileUpload.reset();
            this.csvImport.reset();
        }
    };
    CSVFileImportPage.prototype.setProgress = function (current, total) {
        this.progressCurrent = current;
        this.progressTotal = total;
    };
    CSVFileImportPage.prototype.processFileFailure = function (failed) {
        if (!failed) {
            return;
        }
        this.setImporting(false);
        this.fileUpload.reset();
        notification_service_1.NotificationService.error({ key: i18n_1.T.FILE_NOT_SUPPORTED });
    };
    CSVFileImportPage.prototype.setImporting = function (importing) {
        this.isImporting = importing;
        this.setProgress(0, 0);
    };
    CSVFileImportPage.prototype.importCSVCollections = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.isImporting) {
                            return [2 /*return*/];
                        }
                        this.setProgress(0, this.csvImport.collections.length);
                        this.isImporting = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.processCSVImport()];
                    case 2:
                        _a.sent();
                        this.setImporting(false);
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        notification_service_1.NotificationService.error({ key: i18n_1.T.COLLECTION_IMPORT_FAILED });
                        services_1.Services.Log.Logger.error(e_1, 'Error importing collections');
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    CSVFileImportPage.prototype.importExcelCollections = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var file, rest, attachment, response, importHasProblems, redirectToJob, redirectButton;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.isImporting) {
                            return [2 /*return*/];
                        }
                        this.setImporting(true);
                        file = this.fileUpload.file;
                        rest = services_1.Services.Department.rest;
                        return [4 /*yield*/, rest.Attachment.set(file.name, file.text, file.type)];
                    case 1:
                        attachment = _a.sent();
                        return [4 /*yield*/, rest.Collection.Import.excel({
                                attachmentId: attachment.objectId,
                                formRevision: this.form.value,
                                tagName: this.tagName
                            })];
                    case 2:
                        response = _a.sent();
                        importHasProblems = (response.results.collections.some(function (n) { return n.status === 'error'; })
                            || response.results.meta.length > 0
                            || response.results.collections.length === 0);
                        redirectToJob = function () {
                            var _a;
                            modal_service_1.ModalService.close();
                            services_1.Services.Route.go(page_1.IkePageName.map, { t: response.jobID, collection: (_a = response.results.collections[0].collection) === null || _a === void 0 ? void 0 : _a.uuid });
                        };
                        redirectButton = (0, mithril_1.m)('button', {
                            className: "mdl-button ".concat(modal_style_1.CSS.action.ok),
                            onclick: redirectToJob,
                            type: 'submit'
                        }, (0, i18n_1.Translate)(i18n_1.T.OK));
                        this.setImporting(false);
                        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Import, 'excel:collection', attachment.objectId, response.results.collections.length);
                        if (response.results.collections.length > 0 || response.results.meta.length > 0) {
                            // Display import notifications window
                            modal_service_1.ModalService.open({
                                title: 'Import Notifications',
                                content: renderImportResults(response.jobID, response.results),
                                actions: !importHasProblems ? redirectButton : null
                            });
                            return [2 /*return*/];
                        }
                        else {
                            notification_service_1.NotificationService.error({ key: i18n_1.T.IMPORT_FILE_NO_ROWS });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    CSVFileImportPage.prototype.processFormList = function (summaries) {
        this.form.setOptions(summaries.map(function (c) {
            return { value: c.revision, key: c.displayname };
        }));
    };
    CSVFileImportPage.prototype.processCSVImport = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var collections, file, rest, attachment, mapping, importArgs, _i, mapping_1, info, response, i;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        collections = this.csvImport.collections;
                        file = this.fileUpload.file;
                        rest = services_1.Services.Department.rest;
                        return [4 /*yield*/, rest.Attachment.set(file.name, file.text, file.type)];
                    case 1:
                        attachment = _a.sent();
                        mapping = this.csvImport.mapper.toJSON();
                        importArgs = {
                            attachmentId: attachment.objectId,
                            tagName: this.tag.value,
                            formId: this.csvImport.form.id,
                            mapping: mapping,
                            count: COLLECTION_CHUNK,
                            skip: 0
                        };
                        for (_i = 0, mapping_1 = mapping; _i < mapping_1.length; _i++) {
                            info = mapping_1[_i];
                            services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Import, 'csv:mapping', info.fieldId + ':' + info.csvHeader, 1);
                        }
                        i = 0;
                        _a.label = 2;
                    case 2:
                        if (!(i < collections.length)) return [3 /*break*/, 5];
                        importArgs.skip = i;
                        return [4 /*yield*/, rest.Collection.Import.csv(importArgs)];
                    case 3:
                        response = _a.sent();
                        this.setProgress(i, collections.length);
                        _a.label = 4;
                    case 4:
                        i += COLLECTION_CHUNK;
                        return [3 /*break*/, 2];
                    case 5:
                        notification_service_1.NotificationService.success({ key: i18n_1.T.COLLECTION_IMPORT_SUCCESS, attrs: { count: collections.length } });
                        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Import, 'csv:collection', attachment.objectId, response.results.collections.length);
                        services_1.Services.Route.go(page_1.IkePageName.map, { t: response.results.jobId, collection: response.results.collections[0].uuid });
                        this.setProgress(null, null);
                        return [2 /*return*/];
                }
            });
        });
    };
    CSVFileImportPage.prototype.getCsvNodes = function () {
        if (!this.canImportCSV) {
            return null;
        }
        var children = [];
        children.push(this.viewJobSelector());
        children.push(this.viewFormSelector());
        children.push(this.viewFileUpload());
        if (this.fileUpload.isFilePresent === false || this.form.value == null) {
            return children;
        }
        if (this.isImporting) {
            children.push((0, mithril_1.m)('div', { className: import_style_1.CSS.option.container + ' ' + import_style_1.CSS.option.importing }, [
                (0, mithril_1.m)('div', { className: import_style_1.CSS.option.textContainer }, [
                    spinner_1.Spinner.view(),
                    (0, mithril_1.m)('span', { className: import_style_1.CSS.option.text }, (0, i18n_1.Translate)(i18n_1.T.COLLECTION_IMPORT_PROGRESS, { count: this.progressCurrent, total: this.progressTotal }))
                ])
            ]));
            return children;
        }
        children.push(this.viewFileMappings());
        children.push((0, mithril_1.m)('div', { className: import_style_1.CSS.importButton }, [
            (0, mithril_1.m)('button', { className: 'mdl-button mdl-button--raised mdl-button--accent', disabled: !this.isValid, onclick: this.importCSVCollections }, [
                (0, i18n_1.Translate)(i18n_1.T.COLLECTION_IMPORT_GO)
            ])
        ]));
        return children;
    };
    CSVFileImportPage.prototype.getExcelNodes = function () {
        if (!this.canImportExcel) {
            return null;
        }
        var children = [];
        children.push(this.viewUserGuideLink());
        children.push(this.viewFormSelector());
        children.push(this.viewExcelTemplateDownload());
        children.push(this.viewJobSelector());
        children.push(this.viewFileUpload());
        children.push((0, mithril_1.m)('div', { className: import_style_1.CSS.importButton }, [
            (0, mithril_1.m)('button', { className: 'mdl-button mdl-button--raised mdl-button--accent', disabled: !this.isValid || this.isImporting, onclick: this.importExcelCollections }, [
                this.isImporting ? spinner_1.Spinner.view() : (0, i18n_1.Translate)(i18n_1.T.COLLECTION_IMPORT_GO)
            ])
        ]));
        return children;
    };
    Object.defineProperty(CSVFileImportPage.prototype, "nodes", {
        get: function () {
            var _a, _b;
            var _this = this;
            var nodes = (0, mithril_1.m)('div', { className: import_style_1.CSS.container }, [
                (0, mithril_1.m)('div', { className: import_style_1.CSS.title }, (0, mithril_1.m)('h6', (0, i18n_1.Translate)(i18n_1.T.COLLECTION_IMPORT_TITLE)))
            ]);
            // If the user is not the correct user type OR they don't have access to this feature, then block
            if (!this.canImport) {
                nodes.children.push((0, mithril_1.m)('p', { className: import_style_1.CSS.title }, (0, i18n_1.Translate)(i18n_1.T.COLLECTION_IMPORT_NOT_ALLOWED)));
                return nodes;
            }
            if (this.tabs.length > 0) {
                nodes.children.push((0, mithril_1.m)('div', { class: import_style_1.CSS.tabBar.container }, this.tabs.map(function (tab, i) {
                    var _a;
                    return (0, mithril_1.m)('div', {
                        class: (0, classnames_1.classNames)(import_style_1.CSS.tabBar.tab, (_a = {}, _a[import_style_1.CSS.tabBar.tabActive] = _this.activeTab === i, _a)),
                        onclick: function () {
                            var _a, _b;
                            _this.activeTab = i;
                            (_b = (_a = _this.tabs[i]).onSelect) === null || _b === void 0 ? void 0 : _b.call(_a);
                        }
                    }, tab.title);
                })));
            }
            switch (this.mode) {
                case 'EXCEL':
                    (_a = nodes.children).push.apply(_a, this.getExcelNodes());
                    break;
                case 'CSV':
                    (_b = nodes.children).push.apply(_b, this.getCsvNodes());
                    break;
                default:
            }
            return nodes;
        },
        enumerable: false,
        configurable: true
    });
    CSVFileImportPage.prototype.viewTickOrNeeded = function (isComplete) {
        if (isComplete) {
            return icon_1.Icon.view(icons_1.MaterialIcon.CHECK, { className: import_style_1.CSS.isOptionIconComplete });
        }
        return icon_1.Icon.view(icons_1.MaterialIcon.KEY_RIGHT);
    };
    CSVFileImportPage.prototype.viewJobSelector = function () {
        var isComplete = this.tagName != null;
        var className = import_style_1.CSS.job.container + ' ' + import_style_1.CSS.option.container;
        if (isComplete) {
            className += ' ' + import_style_1.CSS.isOptionComplete;
        }
        return (0, mithril_1.m)('div', { className: className }, [
            (0, mithril_1.m)('div', { className: import_style_1.CSS.option.textContainer }, [
                this.viewTickOrNeeded(isComplete),
                (0, mithril_1.m)('span', { className: import_style_1.CSS.option.text }, (0, i18n_1.Translate)(i18n_1.T.COLLECTION_IMPORT_CHOOSE_JOB))
            ]),
            (0, mithril_1.m)('div', { className: import_style_1.CSS.option.value }, [
                this.tag.view()
            ])
        ]);
    };
    CSVFileImportPage.prototype.viewExcelTemplateDownload = function () {
        var _a;
        var _this = this;
        return (0, mithril_1.m)('div', { className: (0, classnames_1.classNames)(import_style_1.CSS.option.container, (_a = {}, _a[import_style_1.CSS.option.downloadDisabled] = !this.form.value, _a)) }, [
            (0, mithril_1.m)('div', { className: import_style_1.CSS.option.textContainer }, [
                (0, mithril_1.m)('span', { className: import_style_1.CSS.option.text }, (0, i18n_1.Translate)(i18n_1.T.COLLECTION_IMPORT_EXCEL_TEMPLATE))
            ]),
            (0, mithril_1.m)('div', { className: import_style_1.CSS.option.value }, [
                (0, mithril_1.m)('button', {
                    className: import_style_1.CSS.option.download, onclick: function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                        var result;
                        return tslib_1.__generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (this.form.value == null) {
                                        return [2 /*return*/];
                                    }
                                    return [4 /*yield*/, services_1.Services.Department.rest.Collection.exportImportableExcelTemplate({ formVersion: this.form.value })];
                                case 1:
                                    result = _a.sent();
                                    if (result == null) {
                                        return [2 /*return*/];
                                    }
                                    if (result.error) {
                                        notification_service_1.NotificationService.error({ key: export_notification_detail_ctrl_1.MessageReasonTranslations[result.error.reason] });
                                    }
                                    else if (result.url != null) {
                                        services_1.Services.Download.download(result.url, result.fileName);
                                    }
                                    return [2 /*return*/];
                            }
                        });
                    }); }
                }, [icon_1.Icon.view(icons_1.MaterialIcon.FILE_DOWNLOAD), (0, i18n_1.Translate)(i18n_1.T.EXCEL)])
            ])
        ]);
    };
    CSVFileImportPage.prototype.viewUserGuideLink = function () {
        return (0, mithril_1.m)('div', { className: import_style_1.CSS.option.container }, [
            (0, mithril_1.m)('div', { className: import_style_1.CSS.option.textContainer }, [
                (0, i18n_1.Translate)(i18n_1.T.COLLECTION_IMPORT_EXCEL_USER_GUIDE),
                (0, mithril_1.m)('a', { href: (0, i18n_1.Translate)(i18n_1.T.COLLECTION_IMPORT_EXCEL_USER_GUIDE_LINK), target: '_blank', style: "margin-left: ".concat(theme_1.DefaultTheme.space(1)) }, (0, i18n_1.Translate)(i18n_1.T.HERE))
            ])
        ]);
    };
    CSVFileImportPage.prototype.viewFormSelector = function () {
        var isComplete = this.form.value != null;
        var className = import_style_1.CSS.form.container + ' ' + import_style_1.CSS.option.container;
        if (isComplete) {
            className += ' ' + import_style_1.CSS.isOptionComplete;
        }
        return (0, mithril_1.m)('div', { className: className }, [
            (0, mithril_1.m)('div', { className: import_style_1.CSS.option.textContainer }, [
                this.viewTickOrNeeded(isComplete),
                (0, mithril_1.m)('span', { className: import_style_1.CSS.option.text }, (0, i18n_1.Translate)(i18n_1.T.COLLECTION_IMPORT_CHOOSE_FORM))
            ]),
            (0, mithril_1.m)('div', { className: import_style_1.CSS.option.value }, [
                input_select_1.SelectInputComponent.view(this.form)
            ])
        ]);
    };
    CSVFileImportPage.prototype.viewFileUpload = function () {
        var isComplete = this.fileUpload.isFilePresent;
        var className = import_style_1.CSS.file.container + ' ' + import_style_1.CSS.option.container;
        if (isComplete) {
            className += ' ' + import_style_1.CSS.isOptionComplete;
            return (0, mithril_1.m)('div', { className: className }, [
                (0, mithril_1.m)('div', { className: import_style_1.CSS.option.textContainer }, [
                    this.viewTickOrNeeded(isComplete),
                    (0, mithril_1.m)('span', { className: import_style_1.CSS.option.text }, this.mode === 'EXCEL' ? (0, i18n_1.Translate)(i18n_1.T.COLLECTION_IMPORT_FILE_EXCEL) : (0, i18n_1.Translate)(i18n_1.T.COLLECTION_IMPORT_FILE_CSV))
                ]),
                (0, mithril_1.m)('div', { className: import_style_1.CSS.option.value }, [
                    (0, mithril_1.m)('div', this.fileUpload.file.name),
                    this.isImporting ? null : image_button_1.ImageButton.view(icons_1.MaterialIcon.CLOSE, { onclick: this.fileUpload.reset })
                ])
            ]);
        }
        return (0, mithril_1.m)('div', { className: className }, [
            (0, mithril_1.m)('div', { className: import_style_1.CSS.option.textContainer }, [
                this.viewTickOrNeeded(isComplete),
                (0, mithril_1.m)('span', { className: import_style_1.CSS.option.text }, (0, i18n_1.Translate)(i18n_1.T.COLLECTION_IMPORT_CHOOSE_FILE_TYPE, (0, i18n_1.Translate)(this.mode === 'EXCEL' ? i18n_1.T.EXCEL : i18n_1.T.CSV)))
            ]),
            (0, mithril_1.m)('div', { className: import_style_1.CSS.file.drop }, this.fileUpload.view())
        ]);
    };
    CSVFileImportPage.prototype.viewFileMappings = function () {
        var collectionCount = this.csvImport.collections.length;
        var tooManyCollections = (0, mithril_1.m)('div', { className: import_style_1.CSS.isTooManyCollections }, (0, i18n_1.Translate)(i18n_1.T.COLLECTION_IMPORT_TOO_MANY, { count: collectionCount, max: MAX_COLLECTIONS }));
        return (0, mithril_1.m)('div', { className: import_style_1.CSS.csv.container }, [
            (0, mithril_1.m)('div', { className: import_style_1.CSS.option.textContainer }, [
                this.viewTickOrNeeded(this.isValid),
                (0, mithril_1.m)('span', { className: import_style_1.CSS.option.text }, (0, i18n_1.Translate)(i18n_1.T.COLLECTION_IMPORT_MAP_FIELDS))
            ]),
            collectionCount > MAX_COLLECTIONS ? tooManyCollections : null,
            this.csvImport.view()
        ]);
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], CSVFileImportPage.prototype, "isImporting", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], CSVFileImportPage.prototype, "progressCurrent", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], CSVFileImportPage.prototype, "progressTotal", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], CSVFileImportPage.prototype, "mode", void 0);
    tslib_1.__decorate([
        mobx_1.computed
    ], CSVFileImportPage.prototype, "isValid", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], CSVFileImportPage.prototype, "processCSVFile", null);
    tslib_1.__decorate([
        mobx_1.action
    ], CSVFileImportPage.prototype, "setProgress", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], CSVFileImportPage.prototype, "processFileFailure", null);
    tslib_1.__decorate([
        mobx_1.action
    ], CSVFileImportPage.prototype, "setImporting", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], CSVFileImportPage.prototype, "importCSVCollections", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], CSVFileImportPage.prototype, "importExcelCollections", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], CSVFileImportPage.prototype, "processFormList", null);
    return CSVFileImportPage;
}(page_1.IkePage));
exports.CSVFileImportPage = CSVFileImportPage;
function renderImportResults(jobID, results) {
    return (0, mithril_1.m)('div', { className: import_style_1.CSS.importNotifications.container }, tslib_1.__spreadArray([
        results.meta.length ? renderNotifications(results.meta) : null
    ], results.collections.map(function (result) { return renderCollectionResult(jobID, result); }), true));
}
function renderCollectionResult(jobID, result) {
    var _a, _b;
    return (0, mithril_1.m)('div', [
        (0, mithril_1.m)('div', [
            importResultIcon(result.status),
            ((_a = result.collection) === null || _a === void 0 ? void 0 : _a.createdAt)
                ? (0, mithril_1.m)('a', {
                    className: import_style_1.CSS.importNotifications.collectionLink,
                    href: services_1.Services.Route.getRouteURL(page_1.IkePageName.map, {
                        t: jobID,
                        collection: (_b = result.collection) === null || _b === void 0 ? void 0 : _b.uuid
                    })
                }, result.title)
                : result.title,
            "(".concat(translateStatus(result.status), ")")
        ]),
        renderNotifications(result.notifications)
    ]);
}
function importResultIcon(status) {
    switch (status) {
        case 'created': return icon_1.Icon.view(icons_1.MaterialIcon.ADD);
        case 'updated': return icon_1.Icon.view(icons_1.MaterialIcon.EDIT);
        case 'error': return icon_1.Icon.view(icons_1.MaterialIcon.WARNING);
        default: return null;
    }
}
function renderNotifications(notifications) {
    if (notifications.length === 0) {
        return null;
    }
    return (0, mithril_1.m)('table', tslib_1.__spreadArray([
        (0, mithril_1.m)('tr', [
            (0, mithril_1.m)('th', 'Sheet'),
            (0, mithril_1.m)('th', 'Field'),
            (0, mithril_1.m)('th', 'Cell'),
            // m('th', 'Severity'),
            (0, mithril_1.m)('th', 'Reason')
        ])
    ], notifications.map(function (n) { return (0, mithril_1.m)('tr', [
        (0, mithril_1.m)('td', n.sheetName),
        (0, mithril_1.m)('td', n.fieldName),
        (0, mithril_1.m)('td', n.cell),
        // m('td', n.level),
        (0, mithril_1.m)('td', (0, i18n_1.Translate)("REASON_EXPORT_IMPORTABLE_EXCEL_".concat(n.reason.toUpperCase())))
    ]); }), true));
}
function translateStatus(status) {
    switch (status) {
        case 'created': return (0, i18n_1.Translate)(i18n_1.T.CREATED);
        case 'updated': return (0, i18n_1.Translate)(i18n_1.T.UPDATED);
        case 'error': return (0, i18n_1.Translate)(i18n_1.T.SKIPPED);
        default: return '';
    }
}
//# sourceMappingURL=import.page.js.map